import { EmailIcon } from '@chakra-ui/icons'
import { HStack, StackProps, Text } from '@chakra-ui/react'
import WhatsappButton from 'components/buttons/WhatsappButton'
import SectionStack from 'components/common/SectionStack'
import ExternalLink from 'components/links/ExternalLink'
import { OMENS_SUPPORT_EMAIL } from 'constants/omensSupportContact'
import { FC } from 'react'

const ContactSection: FC<StackProps> = (props) => {
  return (
    <SectionStack {...props}>
      <Text textStyle={{ base: 'body1sm', lg: 'body1' }} pb="4px" borderBottom="2px solid #25241E">
        Contato
      </Text>
      <Text textStyle={{ base: 'h5sm', lg: 'h5' }}>Quer uma ajuda mais rápida? Fale com a gente pelo WhatsApp.</Text>
      <WhatsappButton mt="8px" bg="#25241E" textColor="alabaster" iconColor="alabaster" withLabel />
      <ExternalLink
        href={`mailto:${OMENS_SUPPORT_EMAIL}`}
        color="alabaster"
        _hover={{ textColor: 'grayscale.30' }}
        textDecor="none"
        fontWeight="500"
      >
        <HStack>
          <EmailIcon boxSize={5} />
          <Text color="alabaster" _hover={{ textColor: 'grayscale.30' }}>
            {OMENS_SUPPORT_EMAIL}
          </Text>
        </HStack>
      </ExternalLink>
    </SectionStack>
  )
}

export default ContactSection
